module.exports = __webpack_public_path__ + "assets/img/title.f08ccd36.png";